/**
 * Which surface this bundle is. svc-02 reads `appContext` on the platform-issuer
 * exchange (one OIDC client serves both surfaces, so `aud` cannot tell them
 * apart) and enforces it against the signed `pem:user_type` claim.
 *
 * Lives apart from `config/cognito.ts` so modules that must stay free of the
 * Amplify configuration (AxiosService) can import the constant alone.
 */
export const APP_CONTEXT = "admin" as const;
